<!--  -->
<script lang="ts" setup name="Person">
import { computed, unref, type Component } from "vue";
import { type ButtonType, ElButton } from "element-plus";
import { useAppStore } from "@/stores/modules/app";

const appStore = useAppStore();
const getTheme = computed(() => appStore.getTheme);
const props = withDefaults(
  defineProps<{
    type?: ButtonType;
    disabled?: boolean;
    plain?: boolean;
    text?: boolean;
    bg?: boolean;
    link?: boolean;
    round?: boolean;
    circle?: boolean;
    autoInsertSpace?: boolean;
    loading?: boolean;
    loadingIcon?: string | Component;
    darker?: boolean;
    autofocus?: boolean;
    icon?: string | Component;
    tag?: string | Component;
    nativeType?: "button" | "submit" | "reset";
    color?: string;
  }>(),
  {
    type: "primary",
    disabled: false,
    plain: false,
    text: false,
    bg: false,
    link: false,
    round: false,
    circle: false,
    autoInsertSpace: false,
    loading: false,
    darker: false,
    autofocus: false,
    nativeType: "button",
    color: "",
    tag: "button",
  }
);
const emits = defineEmits(["click"]);

const color = computed(() => {
  const { type, link } = props;
  if (type === "primary" && !link) {
    return unref(getTheme).elColorPrimary;
  }
  return "";
});
const style = computed(() => {
  const { type, link } = props;
  if (type === "primary" && !link) {
    return "--el-button-text-color: #fff; --el-button-hover-text-color: #fff";
  }
  return "";
});
</script>
<template>
  <el-button class="color-#fff" :style="style" v-bind="{ ...props }" :color="color" @click="() => emits('click')">
    <slot></slot>
    <slot name="icon"></slot>
    <slot name="loading"></slot>
  </el-button>
</template>

<style lang="scss">
.color-#fff {
  color: #fff;
}
</style>
